export default __webpack_public_path__ + "static/media/woman-1-desktop.6f5b7b54.jpg";